export const probleemAnalyticsEvents = ['probleemAangemaakt'] as const;
